import AvatarPlaceholder from './AvatarPlaceholder';

export default AvatarPlaceholder;
